import { ProductDashboard } from './ProductDashboard';

export default ProductDashboard;
